export default __webpack_public_path__ + "static/media/photogallery-04.86ec6b07.webp";